const state = {
    loading: {
        enable: false,
    },
    layout: {
        empty: {
            class: 'pl-0 pr-0',
        },
    },
    modalStack: [],
};

const getters = {
    getLoading(state) {
        return state.loading;
    },
};

const actions = {};

const mutations = {
    ['loadingEnable'](state, data) {
        if (typeof data === 'boolean') {
            state.loading.enable = data;
        } else {
            state.loading.enable = data.enable;
            state.loading.text = data.text;
        }
    },
    ['loadingIcon'](state, data) {
        state.loading.iconClass = data;
    },
    ['loadingText'](state, data) {
        state.loading.text = data;
    },
    ['emptyLayoutClass'](state, data) {
        state.layout.empty.class = data;
    },
    ['buildUpModal'](state, data) {
        state.modalStack.push(data);
    },
};

export const ui = {
    state,
    actions,
    getters,
    mutations,
};
